import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="page page-enter" style={{ textAlign: 'center', paddingTop: 80 }}>
      <div style={{ fontSize: 80 }} className="animate-float">🎤</div>
      <h1 style={{ fontSize: 64, fontWeight: 900, margin: '16px 0 8px' }} className="gradient-text">404</h1>
      <h2 style={{ marginBottom: 12 }}>This page left the stage</h2>
      <p className="text-muted" style={{ marginBottom: 32 }}>The page you're looking for doesn't exist or was removed.</p>
      <Link to="/" className="btn btn-primary btn-lg">🏠 Back to Home</Link>
    </div>
  );
}
